import { render, staticRenderFns } from "./TakipEkleView.vue?vue&type=template&id=2fff75e4&scoped=true"
import script from "./TakipEkleView.vue?vue&type=script&lang=ts"
export * from "./TakipEkleView.vue?vue&type=script&lang=ts"
import style0 from "./TakipEkleView.vue?vue&type=style&index=0&id=2fff75e4&prod&scoped=true&lang=css"
import style1 from "./TakipEkleView.vue?vue&type=style&index=1&id=2fff75e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fff75e4",
  null
  
)

export default component.exports